/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { inject, observer } from 'mobx-react';
import { useEffect } from 'react';

import './style.scss';

// @ts-ignore
import { Button, Step } from '@microui/react-ui';
//@ts-ignore
import { MicroIcon } from '@microui/react-icons';
import { DetailLayout } from 'components/layouts';
import AddMember from './AddMember';
import AssignPermission from './AssignPermission';

function Main({ store, navigateBack, onCallback }) {
  const { channelId, applicationId, accountId } = store;
  const dataStep = [
    {
      label: 'Thêm thành viên',
    },
    {
      label: 'Phân quyền',
    },
  ];

  useEffect(() => {
    store.resetStore();
    store.formMode = accountId ? 'update' : 'create';

    if (accountId) {
      store.getMemberInfo(channelId, accountId, { applicationId });
    }
  }, []);

  const handleSubmit = () => {
    store.submitData(applicationId, channelId, accountId || store.selectedAccount?.id)
      .then((res) => {
        if (!accountId && !onCallback)
          navigateBack({ applicationId, channelId });

        onCallback && onCallback(res);
      });
  };


  if (accountId) {
    return (
      <DetailLayout
        buttons={[
          <Button
            type="primary"
            color="primary"
            onClick={handleSubmit}
            loading={store.saving}
          >
            Cập nhật
          </Button>
        ].filter(Boolean)}
        navigateBack={() => navigateBack({ applicationId, channelId })}
      >
        <div className="px-6 py-5 flex w-full h-full flex-col">
          <AssignPermission />
        </div>
      </DetailLayout>
    );
  }

  return (
    <DetailLayout
      buttons={[
        store.step == 0 && store.typeAccount == 'invite' &&
        <Button
          type="primary"
          color="primary"
          disabled={!store.selectedAccount}
          onClick={() => store.step += 1}
          suffix={<MicroIcon icon="chevron-right" theme="outlined" color="white" />}
        >
          Tiếp theo
        </Button>,

        store.step == 0 && store.typeAccount == 'create' &&
        <Button
          type="primary"
          color="primary"
          // disabled={!store.selectedAccount}
          onClick={() => store.formCreatorAccount?.submit()}
          suffix={<MicroIcon icon="chevron-right" theme="outlined" color="white" />}
          loading={store.creatingAccount}
        >
          Tạo tài khoản và tiếp tục
        </Button>,

        store.step == 1 &&
        <Button
          type="primary"
          color="primary"
          onClick={handleSubmit}
          loading={store.saving}
        >
          Hoàn thành
        </Button>
      ].filter(Boolean)}
      buttonPlacement="right"
      navigateBack={() => navigateBack({ applicationId, channelId })}
    >
      <div className="px-6 py-5 flex w-full h-full flex-col">
        <div className="w-full flex justify-center items-center mb-6">
          <Step
            stepActive={store.step}
            data={dataStep}
          />
        </div>

        <div className="w-full flex-1 flex justify-center overflow-hidden">
          {store.step === 0 && (
            <AddMember />
          )}

          {store.step === 1 && (
            <AssignPermission />
          )}
        </div>
      </div>
    </DetailLayout>
  );
}

export default inject('store')(observer(Main));
